import React from 'react';

interface ErrorIconProps {
  color?: string;
  size?: string;
}

export const ErrorIcon = ({size = '25', color = '#FF647C'}: ErrorIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10.9249 12.113L11.1881 4.30341H8.80418L9.06734 12.113H10.9249ZM9.99613 15.6966C10.3728 15.6966 10.676 15.5857 10.9056 15.3638C11.1352 15.1419 11.25 14.8607 11.25 14.5201C11.25 14.1744 11.1352 13.8906 10.9056 13.6687C10.676 13.4469 10.3728 13.3359 9.99613 13.3359C9.62461 13.3359 9.32405 13.4481 9.09443 13.6726C8.86481 13.8971 8.75 14.1796 8.75 14.5201C8.75 14.8607 8.86481 15.1419 9.09443 15.3638C9.32405 15.5857 9.62461 15.6966 9.99613 15.6966Z" fill={color}/>
    </svg>
  );
};

export default ErrorIcon;
